export const tokensOverflow = {
    overflow: {
        hidden: 'hidden'
    }
};

//# sourceMappingURL=tokensOverflow.js.map